module.exports = __webpack_public_path__ + "img/marker-oil-produce-yellow.5fde3b18.png";